
import { instance } from "apis/interceptor";
import { TVisitorsOverviewDashBoard } from "types/analytics.types";

type ResponseType<T> = {
  success: boolean;
  statusCode?: number;
  message?: string;
  data?: T;
};

type TOverviewVisitorsDashBoardRequest = {
  start?: string;
  end?: string;
};

//INFO: 월별 방문자 현황 대시보드 조회하기
export async function getVisitorsMonthlyOverviewData(
  data: TOverviewVisitorsDashBoardRequest
): Promise<ResponseType<TVisitorsOverviewDashBoard>> {
  try {
    const res = await instance.post("/analytics/visitors/dashboard/monthly-status", data);
    return { success: true, data: res.data};
  } catch (error: any) {
    return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
  }
}